<template>
  <div>
    <!-- <app-monev_topbar></app-monev_topbar>
    <app-monev_left_sidebar></app-monev_left_sidebar>-->
    <section class="content">
      <div class="container-fluid">
        <div class="row clearfix">
          <div class="bg-light-green" style="margin-top:-1% !important;">
            <!-- <br> -->
            <div class="row paddingku">
              <div class="col-md-3 searching">
                <span class="h_page">Registrasi User</span>
                <br>
                <br>
              </div>
              <div class="col-md-6"></div>
              <div class="col-md-3 searching">
                <div class="input-group">
                  <span class="input-group-btn">
                    <button @click="getAdd" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data">
                      <i class="material-icons">add</i>
                    </button>
                  </span>
                  <input type="text" class="form-control" placeholder="Cari data" id="caridata" @keyup="cari_data" v-model="cari_value">
                </div> <br>
              </div>
            </div>
          </div>
          <div class="col-xs-12 card">
      <!-- ============================================================ MULAI ======================================================================== -->
            <br>
          <!-- ============================================================ TABEL ======================================================================== -->
            <div class="table-responsive">
              <table class="table table-bordered" style="width: 100%">
                <thead>
                  <tr class="bg-info">
                    <th class="text-center" style="width: 5%">No.</th>
                    <th class="text-center" style="width: 20%">Nama</th>
                    <th class="text-center" style="width: 15%">NIP</th>
                    <th class="text-center" style="width: 35%">Instansi</th>
                    <th class="text-center" style="width: 10%">Username</th>
                    <th class="text-center" style="width: 15%">#</th>
                  </tr>
                </thead>
                <tbody>

                    <!-- <template v-for="dn_akun in data.akun_detil" track-by="data11._id" > -->
                      <tr class="h_isitable" v-for="(data, index) in list_data" :key="data.id">
                        <td class="text-center">{{index+1}}.</td>
                        <td>{{data.bio_gelar_depan}} {{data.bio_nama}} {{data.bio_gelar_belakang}}</td>
                        <td class="text-center">{{data.nama_nip}}</td>
                        <td>{{data.unit_kerja_full}}</td>
                        <td>{{data.username}}</td>
                        <td class="text-center">
                          <button @click="getProfile(data.nama_nip)" class="btn bg-light-blue btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_lihat_data">
                            <i class="material-icons">search</i>
                          </button>
                          &nbsp;
                          <button @click="getEdit(data)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                            <i class="material-icons">create</i>
                          </button>
                          &nbsp;
                          <button @click="removeData(data.id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data" >
                            <i class="material-icons">clear</i>
                          </button>

                        </td>
                      </tr>
                    <!-- </template> -->

                </tbody>

              </table>

            </div>
          <!-- ============================================================ TABEL ======================================================================== -->
            <hr>


            <div class="text-center">
              <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                <i class="material-icons">skip_previous</i>
              </button>

              <span style="font-size: 85%; color: #a5a5a5">
                <b>{{page_first}} - {{page_last}}</b>
              </span>

              <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                <i class="material-icons">skip_next</i>
              </button>
            </div>
            <hr>

        <!-- ============================================================ MODAL ======================================================================== -->


          <!-- =========================================================== TAMBAH ================================================================= -->
            <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog" data-backdrop="static">
              <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                  <div class="modal-header bg-light-blue">
                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                  </div>

                  <div class="modal-body">
                    <div v-if="errorMessage" class="alert alert-danger" role="alert">{{ errorMessage }}</div>

                    <div class="row clearfix">
                      <div class="col-md-3 form-control-label">
                        <label for="kode">Unit Kerja</label>
                      </div>
                      <div class="col-md-9">
                        <div class="form-group">
                          <div class="form-line">
                            <autocomplete
                                    :url="URL+ 'api/v1/simpeg_unit_kerja/autocomplete'"
                                    :customHeaders="{authorization: 'kikensbatara '+token }"
                                    anchor="unit_kerja"
                                    :initValue="''"
                                    :placeholder="unit_kerja_full"
                                    :classes="{ input: 'form-control'}"
                                    label="writer"
                                    :onShouldRenderChild="renderChild"
                                    :on-select="getAuto">
                                </autocomplete>
                            <input type="text" id="unit_kerja" class="form-control"  style="display:none">
                            <input type="text" id="unit_kerja_id" class="form-control" style="display:none">
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row clearfix">
                      <div class="col-md-3 form-control-label">
                        <label for="kode">Nama User</label>
                      </div>
                      <div class="col-md-9">
                        <div class="form-group">
                          <div class="form-line">
                                <autocomplete
                                    :url="URL+ 'api/v1/simpeg_biodata/autocomplete1'"
                                    :customHeaders="{authorization: 'kikensbatara '+token }"
                                    :customParams="{ unit_kerja: unit_kerja }"
                                    anchor="nama"
                                    :initValue="''"
                                    :placeholder="'Nama'"
                                    :classes="{ input: 'form-control'}"
                                    label="writer"
                                    :onShouldRenderChild="renderChild1"
                                    :on-select="getAuto1">
                                </autocomplete>

                            <!-- <input type="text" id="nama" class="form-control" @click="getNama">
                            <input type="text" id="nama_nip" class="form-control"  style="display:none"> -->
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row clearfix">
                      <div class="col-md-3 form-control-label">
                        <label for="kode">Username</label>
                      </div>
                      <div class="col-md-9">
                        <div class="form-group">
                          <div class="form-line">
                            <input v-model="dataku.username" type="text" class="form-control" >
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row clearfix">
                      <div class="col-md-3 form-control-label">
                        <label for="kode">Password</label>
                      </div>
                      <div class="col-md-9">
                        <div class="form-group">
                          <div class="form-line">
                            <input v-model="dataku.password" type="text" id="atasan" class="form-control" >
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row clearfix">
                      <div class="col-md-3 form-control-label">
                        <label for="kode">Konfirmasi Password</label>
                      </div>
                      <div class="col-md-9">
                        <div class="form-group">
                          <div class="form-line">
                            <input v-model="dataku.confirmPassword" type="text" id="atasan" class="form-control" >
                          </div>
                        </div>
                          
                      </div>
                    </div>

                    <div class="row clearfix">
                      <div class="col-md-3 form-control-label">
                        <label for="kode">Level Planing</label>
                      </div>
                      <div class="col-md-9">
                        <div class="form-group">
                          <div class="form-line">
                            <select class="form-control" v-model="profile.Planing">
                              <option :value="false">Kunci Akses</option>
                              <option v-for="data in list_level_planning" :key="data.modul_planning_id" :value="data.modul_planning_id">{{data.nama_modul}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row clearfix">
                      <div class="col-md-3 form-control-label">
                        <label for="kode">Level Sakip</label>
                      </div>
                      <div class="col-md-9">
                        <div class="form-group">
                          <div class="form-line">
                            <select class="form-control" v-model="profile.Sakip">
                              <option :value="false">Kunci Akses</option>
                              <option v-for="data in list_level_sakip" :key="data.modul_sakip_id" :value="data.modul_sakip_id">{{data.nama_modul}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row clearfix">
                      <div class="col-md-3 form-control-label">
                        <label for="kode">Level Simpeg</label>
                      </div>
                      <div class="col-md-9">
                        <div class="form-group">
                          <div class="form-line">
                            <select class="form-control" v-model="profile.Simpeg">
                              <option :value="false">Kunci Akses</option>
                              <option v-for="data in list_level_simpeg" :key="data.modul_simpeg_id" :value="data.modul_simpeg_id">{{data.nama_modul}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <hr>


                  </div>
                  <div class="modal-footer">
                    <button @click="addData" type="button" class="btn btn-info waves-effect">SIMPAN</button>
                    <button  @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                  </div>
                </div>
              </div>
            </div>
          <!-- =========================================================== TAMBAH ================================================================= -->


          <!-- =========================================================== EDIT ================================================================= -->
            <!-- </div> -->
            <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
              <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                  <div class="modal-header bg-light-green">
                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                  </div>
                  <div class="modal-body">

                    <div class="row clearfix">
                      <div class="col-md-3 form-control-label">
                        <label for="kode">Username</label>
                      </div>
                      <div class="col-md-9">
                        <div class="form-group">
                          <div class="form-line">
                            <input v-model="dataku.username" type="text" class="form-control" >
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row clearfix">
                      <div class="col-md-3 form-control-label">
                        <label for="kode">Password</label>
                      </div>
                      <div class="col-md-9">
                        <div class="form-group">
                          <div class="form-line">
                            <input v-model="dataku.password" type="text" id="atasan" class="form-control" >
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row clearfix">
                      <div class="col-md-3 form-control-label">
                        <label for="kode">Konfirmasi Password</label>
                      </div>
                      <div class="col-md-9">
                        <div class="form-group">
                          <div class="form-line">
                            <input v-model="dataku.confirmPassword" type="text" id="atasan" class="form-control" >
                          </div>
                        </div>
                          
                      </div>
                    </div>

                    <div class="row clearfix">
                      <div class="col-md-3 form-control-label">
                        <label for="kode">Level Planing</label>
                      </div>
                      <div class="col-md-9">
                        <div class="form-group">
                          <div class="form-line">
                            <select class="form-control" v-model="profile.Planing">
                              <option :value="false">Kunci Akses</option>
                              <option v-for="data in list_level_planning" :key="data.modul_planning_id" :value="data.modul_planning_id">{{data.nama_modul}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row clearfix">
                      <div class="col-md-3 form-control-label">
                        <label for="kode">Level Sakip</label>
                      </div>
                      <div class="col-md-9">
                        <div class="form-group">
                          <div class="form-line">
                            <select class="form-control" v-model="profile.Sakip">
                              <option :value="false">Kunci Akses</option>
                              <option v-for="data in list_level_sakip" :key="data.modul_sakip_id" :value="data.modul_sakip_id">{{data.nama_modul}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row clearfix">
                      <div class="col-md-3 form-control-label">
                        <label for="kode">Level Simpeg</label>
                      </div>
                      <div class="col-md-9">
                        <div class="form-group">
                          <div class="form-line">
                            <select class="form-control" v-model="profile.Simpeg">
                              <option :value="false">Kunci Akses</option>
                              <option v-for="data in list_level_simpeg" :key="data.modul_simpeg_id" :value="data.modul_simpeg_id">{{data.nama_modul}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr>
                  </div>
                  <div class="modal-footer">
                    <button @click="editData" type="button" class="btn btn-success waves-effect">RUBAH</button>
                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                  </div>
                </div>
              </div>
            </div>
          <!-- =========================================================== EDIT ================================================================= -->



          <!-- =========================================================== LIHAT ================================================================= -->
            <div class="modal fade" id="m_lihat_data" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
              <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                  <div class="modal-header bg-light-blue">
                    <h4 class="modal-title" id="largeModalLabel">DETIL DATA</h4>
                  </div>
                    <div class="modal-body">
                      <hr>
                      <transition name="fade">
                        <div v-if="modal_profile">
                          <profil_user></profil_user>
                        </div>
                      </transition>
                      
                  </div>
                  <div class="modal-footer">
                    <button @click="closeProfile()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal" >KEMBALI</button>
                  </div>
                </div>
              </div>
            </div>
          <!-- =========================================================== LIHAT ================================================================= -->

        <!-- ============================================================ MODAL ======================================================================== -->

      <!-- ============================================================ MULAI ======================================================================== -->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
// const ADD_URL = URL_APP + "auth/signup";


import Joi from "joi";
const ADD_URL = URL_APP + "api/v1/reg_registrasi/";
const ADD_URL_UPDATE = URL_APP + "api/v1/reg_update_users/";
const SIGNUP_URL = URL_APP + "auth/signup";
const URL_SERVER = URL_APP;
import Autocomplete from 'vue2-autocomplete-js'




const schema = Joi.object().keys({
  username: Joi.string().regex(/^[a-zA-Z0-9_]*$/).min(3).max(13).required(),
  password: Joi.string().min(6).required(),
});


export default {

  name : 'monev_user',
   components: { Autocomplete },
  data: function() {
    return {
      dataku: {
        username : "",
        password : "",
        confirmPassword: "",
      },

      profile:{
        id : "",
        unit_kerja : "",
        unit_kerja_id : "",
        nama : "",
        nama_nip : "",

        Office : true,
        Planing : false,
        Simpeg : false,
        Bhumie : false,
        Aset : false,
        Monev : false,
        Berita : false,
        Pengaduan : false,
        Sakip : false,
        CCTV : false,
        Linja : false,
        Registrasi : false,

        unit_kerja_alamat :'',
        bio_nama :'',
        bio_gelar_depan :'',
        bio_gelar_belakang :'',
        bio_tempat_lahir :'',
        bio_ttl :'',
        bio_gol :'',
        bio_jabatan :'',
        bio_alamat :'',
      },

      modal_profile : false,

      list_data: [],
      list_level_planning: [],
      list_level_simpeg: [],
      list_level_sakip: [],
      page_first: 1,
      page_last: 0,
      cari_value: "",
      URL : URL_SERVER,
      token : localStorage.token,

      unit_kerja : '',
      unit_kerja_full : '',
      unit_kerja_edit : '',

      signingUp : false,
      errorMessage: "",
    };
  },

  methods: {
    getView: function() {
      fetch(ADD_URL + "view", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value
        })
      })
        .then(res => res.json())
        .then(res_data => {
          this.list_data = res_data.data;
          this.page_last = res_data.jml_data;
          // console.log(res_data);
        });
    },

    addData: function() {
      this.errorMessage = "";
        if (this.validUser()) {
            // Jika user sdh valid lakukan pengiriman data ke server
            const body = {
              username: this.dataku.username,
              password: this.dataku.password
            };
            this.signingUp = true;
            fetch(SIGNUP_URL, {
                method: "POST",
                body: JSON.stringify({

                  username: this.dataku.username,
                  password: this.dataku.password,

                  unit_kerja_id : this.profile.unit_kerja_id,
                  nama_nip :  this.profile.nama_nip,
                  Office : this.profile.Office,
                  Planing : this.profile.Planing,
                  Simpeg : this.profile.Simpeg,
                  Bhumie : this.profile.Bhumie,
                  Aset : this.profile.Aset,
                  Monev : this.profile.Monev,
                  Berita : this.profile.Berita,
                  Pengaduan : this.profile.Pengaduan,
                  Sakip : this.profile.Sakip,
                  CCTV : this.profile.CCTV,
                  Linja : this.profile.Linja,
                  Registrasi : this.profile.Registrasi,
                }),
                headers: {
                    "content-type": "application/json"
                }
            }).then((response) => {
                this.getView();
                this.alertku("success", "sukses menambah data");
                if (response.ok) {
                  return response.json();
                }
                else{
                  return response.json().then(error => {
                    throw new Error(error.message);
                  });

                }
            })
            .catch((error) => {
              setTimeout(() => {
                this.signingUp = false;
                this.errorMessage = "Username mungkin sudah digunakan orang lain, error :"+error.message;
              }, 1000);
                // console.log(error);
            });
        }else{
          console.log("tidak valid");

        }

    },

    validUser : function(){
      if (this.dataku.password !== this.dataku.confirmPassword) {
          this.errorMessage = "Password harus sama. !";
          return false;
      }
      // Memulai proses validasi melalui skema Joi yang sebelumnya dibuat
      // req.body merupakan data yang di kirim oleh client dan schema merupakan skema joi yg di buat sebelumnya
      const body = {
              username: this.dataku.username,
              password: this.dataku.password
      };
      const result = Joi.validate(body, schema);

      if (result.error === null) {
          return true;
      }
      if (result.error.message.includes("username")) {
          // jika pesan error yang dihasilkan mengandung char "username" maka
          this.errorMessage = "Username tidak valid";
      } else {
          this.errorMessage = "Password tidak valid";
          console.log(result.error);

      }
      return false;
    },

    removeData: function(id_data) {
      fetch(ADD_URL + "remove", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({ id: id_data })
      }).then(res_data => {
        this.getView();
        this.alertku("success", "sukses menghapus data");
        this.autocompleted();
      });
      // console.log(id_data);
    },

    emptyData : function(){
      this.list_level_planning = [];
    },

    editData: function() {
      fetch(ADD_URL_UPDATE + "registrasi_update_data", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify(this.profile)
      }).then(res_data => {
        this.getView();
        this.alertku("success", "sukses merubah data");
        this.autocompleted();
      });
    },
    getEdit: function(data) {

      console.log(data);
        this.get_level_planning();
        this.dataku.username = data.username;
        this.profile.id = data.id;
        this.profile.unit_kerja = data.unit_kerja_full;
        this.profile.unit_kerja_id = data.unit_kerja_id;
        this.profile.nama = data.bio_nama;
        this.profile.nama_nip = data.nama_nip;
        this.profile.Office = data.Office;
        this.profile.Planing = data.Planing;
        this.profile.Simpeg = data.Simpeg;
        this.profile.Bhumie = data.Bhumie;
        this.profile.Aset = data.Aset;
        this.profile.Monev = data.Monev;
        this.profile.Berita = data.Berita;
        this.profile.Pengaduan = data.Pengaduan;
        this.profile.Sakip = data.Sakip;
        this.profile.CCTV = data.CCTV;
        this.profile.Linja = data.Linja;
        this.profile.Registrasi = data.Registrasi;
        this.profile.unit_kerja_alamat = data.unit_kerja_alamat;
        this.profile.bio_nama = data.bio_nama;
        this.profile.bio_gelar_depan = data.bio_gelar_depan;
        this.profile.bio_gelar_belakang = data.bio_gelar_belakang;
        this.profile.bio_tempat_lahir = data.bio_tempat_lahir;
        this.profile.bio_ttl = data.bio_ttl;
        this.profile.bio_gol = data.bio_gol;
        this.profile.bio_jabatan = data.bio_jabatan;
        this.profile.bio_alamat = data.bio_alamat;
        // alert(this.profile.nama)
        this.get_level_planning();
        this.get_level_sakip();
        this.get_level_simpeg();
    },
    getProfile(id){
      localStorage.profile_id = id;
      this.modal_profile = true;
    },
    closeProfile(){
      localStorage.profile_id = "";
      this.modal_profile = false;
    },

// ================== TAMBAHAN ====================

    getAdd : function(){
      this.get_level_planning();
      this.get_level_sakip();
      this.get_level_simpeg();
    },
    get_level_planning: function() {
      fetch(ADD_URL + "level_planning", {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        }
      })
        .then(res => res.json())
        .then(res_data => {
          // console.log(res_data);
          this.list_level_planning = res_data;
        });
    },
    
    get_level_sakip: function() {
      fetch(ADD_URL + "level_sakip", {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        }
      })
        .then(res => res.json())
        .then(res_data => {
          // console.log(res_data);
          this.list_level_sakip = res_data;
        });
    },
    get_level_simpeg: function() {
      fetch(ADD_URL + "level_simpeg", {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        }
      })
        .then(res => res.json())
        .then(res_data => {
          console.log(res_data);
          this.list_level_simpeg = res_data;
        });
    },
// ================== TAMBAHAN ====================
  // ================== PAGINASI ====================
    alertku: function(type, title) {
      this.$swal({
        type: type,
        title: title,
        showConfirmButton: false,
        timer: 800
      });
    },

    btn_prev: function() {
      if (this.page_first > 1) {
        this.page_first--;
      } else {
        this.page_first = 1;
      }
      this.getView();
    },

    btn_next: function() {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last;
      } else {
        this.page_first++;
      }
      this.getView();
    },

    cari_data: function() {
      this.getView();
    },
    getNama : function(){
      var unit_Kerja = document.getElementById("unit_kerja_id").value;
      // this.autocompleted1(unit_Kerja)
    },

    // ================== AUTOCOMPLETE ====================
        renderChild(data) {
            return `
            <span><b>${data.unit_kerja}</b></span>
            <span style='font-size:80%'>${data.ref_instansi}</span>
            `
        },
        getAuto : function(obj){
            this.unit_kerja = obj.id;
            this.unit_kerja_full = obj.unit_kerja;
            this.profile.unit_kerja_id = obj.id;
            console.log(obj);
        },

        renderChild1(data) {
            return `
            <span><b>${data.nama}</b></span>
            <span style='font-size:80%'>NIP. ${data.nip}</span>
            `
        },
        getAuto1 : function(obj){
          this.profile.nama_nip = obj.nip;
            // this.nama_nip = obj.id;
            // this.unit_kerja_full = obj.unit_kerja;
            // console.log(obj);
        },
    // ================== AUTOCOMPLETE ====================
    





  // ================== PAGINASI ====================
  },

  watch: {
        dataku: {
            handler() {
                this.errorMessage = "";
            },
            deep: true
        }
  },
  mounted: function() {
    localStorage.sidemenu = 'registrasi';
    this.getView();
    // this.autocompleted();
  }
};
</script>

<style>
</style>
